import React from 'react';
import { Pie, PieChart, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import { colors } from '../../config';
import CloverConnectionStatuses from 'types/models/CloverConnectionStatuses';

const COLORS = [colors.cloverConnected, colors.cloverUnstable, colors.cloverDisconnected, colors.black];

export default ({ cloverPointStatuses, t }: {cloverPointStatuses: CloverConnectionStatuses, t: any}): JSX.Element => {

    const renderCustomizedLabel = ({ value, percent }) => {
        return `${value} (${(percent * 100).toFixed(1)}%)`;
    };

    const data = React.useMemo(() => {
        return [
            {name: t('clover-connection-status.connected'), value: cloverPointStatuses.online},
            {name: t('clover-connection-status.unstable'), value: cloverPointStatuses.unstable},
            {name: t('clover-connection-status.disconnected'), value: cloverPointStatuses.offline},
            {name: t('clover-connection-status.inactive'), value: cloverPointStatuses.isInactive},
        ];
    }, [cloverPointStatuses]);

  return (
        <ResponsiveContainer>
            <PieChart>
                <Pie
                dataKey="value"
                data={data}
                cx="50%"
                cy="50%"
                outerRadius={120}
                label={renderCustomizedLabel}
                >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
                </Pie>
                <Tooltip formatter={(value, name, props) => [`${value} (${((props.percent ?? 0) * 100).toFixed(1)}%)`, name]} />
            </PieChart>
        </ResponsiveContainer>
    
  );
}